import { ref } from 'vue';
import { defineStore } from "pinia";
import {
  type IssueCategoryDto,
  type CreateIssueCategoryDto,
  type UpdateIssueCategoryDto,
  IssueCategoriesService,
} from '@/client';

export const useIssueCategoryStore = defineStore("issueCategory", () => {
  const categories = ref([] as IssueCategoryDto[]);

  async function list() {
    return await IssueCategoriesService.getApiIssueCategoriesList()
      .then((data) => {
        categories.value = data!;
        return Promise.resolve(data);
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function create(dto: CreateIssueCategoryDto) {
    return await IssueCategoriesService.postApiIssueCategoriesCreate({ requestBody: dto })
      .then((data) => {
        categories.value.push(data!);
        return Promise.resolve(data);
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function update(dto: UpdateIssueCategoryDto) {
    return await IssueCategoriesService.putApiIssueCategoriesUpdate({ requestBody: dto })
      .then((data) => {
        const idx = categories.value.findIndex(c => c.id === dto.id);
        if (idx !== -1) categories.value[idx] = data!;
        return Promise.resolve(data);
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function remove(id: number) {
    return await IssueCategoriesService.deleteApiIssueCategoriesDeleteById({ id: String(id) })
      .then(() => {
        categories.value = categories.value.filter(c => c.id !== id);
        return Promise.resolve();
      })
      .catch((error: any) => Promise.reject(error));
  }

  return { categories, list, create, update, remove };
});
